import * as React from 'react';

import { ComponentWithInnerHTML } from '@cian/frontend-e2e-deal-component';
import { Typography } from '../../../Typography';
import { Label } from '../../../Label';

import * as styles from './styles.css';
import { IJob } from '../../../../types/job';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

const { Text } = Typography;

export const Job: React.FC<IJob> = ({ name, labels }) => {
  const deviceType = useDeviceType();

  return (
    <div className={cn(styles.root, styles[deviceType])}>
      <div className={cn(styles.name, styles[deviceType])}>
        {deviceType === 'desktop' ? (
          <Text level={1} fontWeight="bold">
            <ComponentWithInnerHTML html={name} />
          </Text>
        ) : (
          <Text level={2} fontWeight="bold">
            <ComponentWithInnerHTML html={name} />
          </Text>
        )}
      </div>
      <div className={cn(styles.labels, styles[deviceType])}>
        {labels.map((label, index) => {
          return (
            <div key={index} className={styles.label}>
              <Label text={label} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

Job.displayName = 'Job';
